import React from 'react';
import { Route } from 'react-router-dom';
import AllowRole from 'src/components/AllowRole';
import AddObserverPage from 'src/pages/observers/AddObserverPage';
import AddQueryGroupPage from 'src/pages/observers/AddQueryGroupPage';
import ListObserverPage from 'src/pages/observers/ListObserversPage';
import AddModulePage from 'src/pages/observers/module/AddModulePage';
import ListModulesPage from 'src/pages/observers/module/ListModulesPage';

export default function ObserversRoutes() {
	return (
		<>
			<Route path="/observador" element={<AllowRole role={'user'} />}>
				<Route
					path="listar"
					element={ <ListObserverPage /> }
				/>
				<Route
					path="adicionar"
					element={ <AddObserverPage /> }
				/>
				<Route
					path="grupo/adicionar"
					element={ <AddQueryGroupPage /> }
				/>
				<Route
					path="modulo"
					element={<AllowRole role={'partner'} />}
				>
					<Route
						path="listar"
						element={ <ListModulesPage /> }
					/>
					<Route
						path="adicionar"
						element={ <AddModulePage /> }
					/>
				</Route>
			</Route>
		</>
	);
}
